import NotificationSVG from "@design-system/ui-icons/vanilla/Notification"
import { createIcon } from "../createIcon"

export const NotificationIcon = createIcon(NotificationSVG)
